import { render, staticRenderFns } from "./unauthorized.vue?vue&type=template&id=57d1c56e&scoped=true&"
import script from "./unauthorized.vue?vue&type=script&lang=js&"
export * from "./unauthorized.vue?vue&type=script&lang=js&"
import style0 from "./unauthorized.vue?vue&type=style&index=0&id=57d1c56e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d1c56e",
  null
  
)

export default component.exports